import * as React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, DialogContentText } from '@material-ui/core'
import Form from 'components/presenter/form/Form'
import { useForm } from 'libs/form/formHook'
import { useStore, companyStoreId } from 'stores'
import { useSnackbar } from 'libs/ui/snackbar'
import * as styles from './dialog.module.css'

const DeleteLocationDialog = ({shop, open, onClose, onDelete}) => {
  const { t } = useTranslation()
  const companyStore = useStore(companyStoreId)
  const { showSuccess } = useSnackbar()
  const { isFormReady, requestAsyc, isLoading } = useForm({})

  const triggerOnDelete = async () => {
    if (onDelete) {
      const response = await requestAsyc(companyStore.actions.deleteShopLocation({
        locationId: shop._id,
      }))
      if(!response.error) {
        showSuccess(t('common.success'))
        onDelete()
      }
    }
  }
  return (
    <Dialog
      className={styles.dialog}
      open={open}
      onClose={onClose}
    >
      <DialogTitle className={styles.titleTxt}>{t('shopLocation.deleteLocation')}</DialogTitle>
      <DialogContent>
        <Form className={styles.form} isLoading={isLoading}>
          <DialogContentText className={styles.content}>
            {t('shopLocation.confirmDeleteLocation', {
              name: shop.name
            })}
          </DialogContentText>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button className="mui-dialog-btn-nok" onClick={onClose}>
          {t('common.cancel')}
        </Button>
        <Button className="mui-dialog-btn-ok" onClick={triggerOnDelete} disabled={!isFormReady()}>
          {t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteLocationDialog